export default "__VITE_ASSET__DFOofOU0__"